module.exports = __webpack_public_path__ + "img/capture_2.bcf18e86.jpg";